// extracted by mini-css-extract-plugin
export default {"label":"_3gfzD","gender":"_2P9kr","error":"_1d8Us","radio":"_2XJ3i","errorMessage":"_2-zVF"};